import React, { useState, useEffect } from 'react';
import styles from './index.module.less';
import {
  Row,
  Col,
  Card,
  Space,
  Form,
  Select,
  // Input,
  DatePicker,
  Tabs
} from 'antd';
import Layout from '@/common/Layout';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  //   Legend,
  ResponsiveContainer
} from 'recharts';
import { QrReader } from 'react-qr-reader';
import { CloudDownloadOutlined, QrcodeOutlined } from '@ant-design/icons';
import CustomButton from '@/common/CustomButton';
import FormItem from '@/common/FormItem';
import { useLocation } from 'react-router-dom';
import moment from 'moment';

const { RangePicker } = DatePicker;
const EMS = () => {
  const [form] = Form.useForm();
  const [openCam, setOpenCam] = useState(false);

  const searchParam = useLocation().search;
  const searchParams = new URLSearchParams(searchParam);

  const metrics = [
    {
      last_value: '3°c',
      name: 'Temperature',
      time: '2025-05-14 19:42:42'
    },
    {
      last_value: 5,
      name: 'RH',
      time: '2025-05-14 19:42:42'
    }
  ];
  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  const generateTemperatureData = () => {
    const data = [];
    const now = new Date();

    for (let i = 12; i >= 0; i--) {
      const time = new Date(now);
      time.setHours(time.getHours() - i);

      data.push({
        time: time.toISOString(),
        Average: Math.floor(70 + Math.random() * 15)
      });
    }

    return data;
  };
  const [temperatureData, setTemperatureData] = useState([]);

  useEffect(() => {
    // In a real app, you would fetch data here
    setTemperatureData(generateTemperatureData());
  }, []);

  const handleError = (err) => {
    console.error(err);
  };

  const onSearch = (e) => {
    console.log(e);
  };

  const handleQrScan = async (scanData) => {
    if (scanData && scanData !== '') {
      console.log(scanData);

      form.setFieldsValue({ equipment_id: scanData.text });
      setOpenCam(false);
    }
  };
  return (
    <>
      <Layout sider={false}>
        <Card
          className={`${styles.cardStyles_approver}`}
          title={`Environment Monitoring System
 `}
        >
          <>
            <Form layout="vertical">
              <Row gutter={24}>
                <Col span={1}>
                  <CustomButton
                    className={styles.qrcode}
                    onClick={() => setOpenCam(true)}
                    style={{ marginTop: '24px' }}
                    disabled={searchParams.get('id')}
                  >
                    <QrcodeOutlined />
                  </CustomButton>
                </Col>
                <Col span={6}>
                  <FormItem
                    label="Room Number"
                    name="room_no"
                    rules={[
                      {
                        required: true,
                        message: 'Select Product name'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Select
                      placeholder="Select Room Number"
                      showSearch
                      optionFilterProp="children"
                      //   onChange={onChangeBatch}
                      onSearch={onSearch}
                      disabled={searchParams.get('id')}
                    >
                      <option>Room1</option>
                    </Select>
                  </FormItem>
                </Col>
                <Col xs={24} xl={8} span={8} md={24} sm={24}></Col>
                <Col xs={24} xl={6} span={6} md={24} sm={24}>
                  <FormItem
                    label="Download Report"
                    name="fromDate"
                    rules={[
                      {
                        required: true,
                        message: 'Enter Select date'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <RangePicker
                      format={'YYYY-MM-DD'}
                      style={{ width: '100%' }}
                    />
                  </FormItem>
                </Col>
                <Col span={2}>
                  <CustomButton
                    className={styles.qrcode}
                    style={{ marginTop: '24px' }}
                  >
                    <CloudDownloadOutlined />
                  </CustomButton>
                </Col>
              </Row>
            </Form>
          </>
        </Card>
        <br />
        <Card className={`${styles.cardStyles_approver1}`}>
          <Form form={form} layout="vertical">
            <Row gutter={24}>
              {metrics?.map((item, index) => {
                return (
                  <>
                    <Col span={6} key={index} style={{ marginTop: '25px' }}>
                      <Card className={styles.BGimage}>
                        <Space
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            width: '100%'
                          }}
                        >
                          <span className="mb-2 text-gray-600">
                            {item.name}
                          </span>
                          {item.time && (
                            <span
                              style={{ fontSize: '13px', marginLeft: 'auto' }}
                            >
                              {`${moment(item.time).format('hh:mm A')}`}
                            </span>
                          )}
                        </Space>
                        <span style={{ fontSize: '40px' }}>
                          {item?.last_value}
                        </span>
                        {/* </CardContent> */}
                      </Card>
                    </Col>
                  </>
                );
              })}
            </Row>
            <br />
            <Row gutter={24}>
              <Col span={24}>
                <Tabs defaultActiveKey="1" type="card">
                  {metrics?.map((item, index) => {
                    const maxAverage =
                      item?.average_data && Array.isArray(item?.average_data)
                        ? Math.max(...item.average_data.map((d) => d.Average))
                        : 0;
                    return (
                      <Tabs.TabPane tab={item?.name} key={index}>
                        <div className="h-64">
                          <ResponsiveContainer width="100%" height={300}>
                            <LineChart data={temperatureData}>
                              <CartesianGrid strokeDasharray="3 3" />
                              <XAxis
                                dataKey="time"
                                tickFormatter={formatTime}
                              />
                              <YAxis domain={[0, parseInt(maxAverage) + 10]} />
                              <Tooltip
                                labelFormatter={(time) => formatTime(time)}
                              />
                              {/* <Legend /> */}
                              <Line
                                type="monotone"
                                dataKey="Average"
                                stroke="#e80e94"
                                fill="#e80e94"
                                strokeWidth={2}
                              />
                            </LineChart>
                          </ResponsiveContainer>
                        </div>
                      </Tabs.TabPane>
                    );
                  })}
                </Tabs>
              </Col>
            </Row>
          </Form>
        </Card>
        {openCam ? (
          <QrReader
            constraints={{
              facingMode: 'environment', // Use rear camera
              width: { ideal: 1280 },
              height: { ideal: 720 }
            }}
            delay={1000}
            onError={handleError}
            onResult={handleQrScan}
            style={{
              width: '3px',
              height: '3px'
            }}
          />
        ) : (
          ''
        )}
      </Layout>
    </>
  );
};

export default EMS;
